import React, { createContext, useState } from 'react';

// Créer le contexte
const LanguageContext = createContext();

// Définir les traductions
const translations = {
  fr: {
    // Navbar & Navigation
    accueil: 'Accueil',
    competences: 'Compétences',
    services: 'Services',
    projects: 'Projets',
    contact: 'Contact',
    
    // Page d'accueil
    role: 'Développeur Web & DevOps',
    greeting: `Développeur passionné de 21 ans, sur le point d'entrer en Master 2, 
              je transforme des idées en expériences numériques performantes`,
    description: `Spécialisé dans le développement web avec une sensibilité DevOps, 
                je combine créativité et rigueur technique pour concevoir des solutions fiables et innovantes qui dépassent les attentes`,
    cv: 'Voir mon CV',
    contactMe: 'Me contacter',
    seeProjects: 'Voir mes projets',
    
    // Page Services
    servicesTitle: 'Solutions sur Mesure pour Votre Succès Digital',
    servicesIntro: `Transformez votre vision digitale en réalité ! En tant que développeur passionné, 
                  je mets mon expertise technique et ma créativité au service de votre réussite en ligne. 
                  De la conception à la maintenance, bénéficiez d'un accompagnement personnalisé 
                  pour faire rayonner votre présence numérique.`,
    webDevTitle: 'Développement Web',
    webDevDesc: `Création de sites web et applications innovantes, alliant performance technique 
                et expérience utilisateur exceptionnelle. Du design à la mise en production, 
                je vous accompagne dans la réalisation de votre vision digitale.`,
    seoTitle: 'SEO & Marketing Digital',
    seoDesc: `Maximisez votre visibilité en ligne grâce à une stratégie SEO complète et personnalisée. 
              Améliorez votre classement dans les moteurs de recherche et attirez un trafic qualifié 
              vers votre site.`,
    maintenanceTitle: 'Maintenance & Support',
    maintenanceDesc: `Assurez la pérennité et la sécurité de votre présence en ligne grâce à un 
                    service de maintenance proactif et un support technique réactif. Concentrez-vous 
                    sur votre activité pendant que je veille sur votre infrastructure digitale.`,
    recommended: 'Recommandé',
    learnMore: 'En savoir plus',
    needCustom: `Besoin d'une solution personnalisée ? Contactez-moi pour discuter de votre projet.`,
    discussProject: "Discuter de votre projet",
    
    // Page Contact
    contactTitle: "Parlons de votre projet",
    contactIntro: `Une idée ? Un projet ? N'hésitez pas à me contacter pour en discuter.`,
    fullName: 'Nom complet',
    email: 'Adresse email',
    subject: 'Objet',
    message: 'Message',
    sending: 'Envoi en cours...',
    send: 'Envoyer le message',
    successMessage: 'Votre message a été envoyé avec succès !',
    errorMessage: 'Une erreur est survenue lors de l\'envoi du message.',
    
    // Sujets prédéfinis
    webSubject: 'Demande d\'information - Développement Web',
    seoSubject: 'Demande d\'information - SEO & Marketing Digital',
    maintenanceSubject: 'Demande d\'information - Maintenance & Support',
    
    // Page Compétences
    skillsTitle: 'Mes Compétences',
    skillsIntro: `Passionné par les technologies web et DevOps, j'ai développé une expertise 
                diversifiée en développement full-stack et en administration système. 
                Mon approche combine créativité technique et méthodologies agiles pour 
                créer des solutions robustes et évolutives.`,
    frameworks: 'Frameworks',
    devops: 'DevOps & Cloud',
    versionControl: 'Gestion de Version',
    os: 'Systèmes d\'Exploitation',
    databases: 'Bases de Données',
    methods: 'Méthodes & Analyses',
    
    // Page Projets
    projectsTitle: 'Mes Projets',
    projectsIntro: 'Découvrez une sélection de mes réalisations, illustrant mon expertise en développement web et ma capacité à créer des solutions innovantes.',
    viewOnGithub: 'Voir sur GitHub',
    interestedProjects: 'Intéressé par mes réalisations ? Discutons de votre prochain projet !',
    technologiesUsed: 'Technologies utilisées',
    easyfoundTitle: 'EASYFOUND',
    easyfoundDesc: "Solution de Growth Hacking automatisée conçue pour la prospection de masse ultra-personnalisée. Développée pour maximiser les taux de conversion sans tomber dans le spam, la plateforme intègre des algorithmes de filtrage intelligents et une infrastructure d'envoi optimisée.",
    afrixportTitle: 'AFRIXPORT B2B',
    afrixportDesc: "Écosystème technologique dédié à la digitalisation des échanges commerciaux entre l'Afrique et l'international. Cette marketplace B2B complexe automatise l'intégralité de la chaîne de valeur : du sourcing fournisseur à la sécurisation des transactions financières (Escrow), jusqu'à l'optimisation logistique transfrontalière.",
    bs2Title: 'BOXING SUPERSTAR 2 (BS2)',
    bs2Desc: "Suite de Boxing Superstar 1 avec nouvelles fonctionnalités : suivi avancé des performances, coaching personnalisé, intégration sociale et améliorations UX/UI.",
    
    // Noms des langues
    languageFr: 'Français',
    languageEn: 'English',
    languageLb: 'Lëtzebuergesch',
  },
  en: {
    // Navigation
    accueil: 'Home',
    competences: 'Skills',
    services: 'Services',
    projects: 'Projects',
    contact: 'Contact',
    
    // Home page
    role: 'Web Developer & DevOps',
    greeting: 'Passionate 21-year-old developer, about to enter Master\'s degree, I transform ideas into exceptional digital experiences.',
    description: 'Specialized in web development with a DevOps sensitivity, I combine creativity and technical rigor to design reliable and innovative solutions that exceed expectations.',
    cv: 'See my CV',
    contactMe: 'Contact me',
    seeProjects: 'See projects',
    
    // Services page
    servicesTitle: 'Custom Solutions for Your Digital Success',
    servicesIntro: `Transform your digital vision into reality! As a passionate developer, 
                  I put my technical expertise and creativity at the service of your online success. 
                  From design to maintenance, benefit from personalized support 
                  to make your digital presence shine.`,
    webDevTitle: 'Web Development',
    webDevDesc: `Creation of innovative websites and applications, combining technical performance 
                and exceptional user experience. From design to production, 
                I accompany you in the realization of your digital vision.`,
    seoTitle: 'SEO & Digital Marketing',
    seoDesc: `Maximize your online visibility with a comprehensive and personalized SEO strategy. 
              Improve your search engine ranking and attract qualified traffic to your site.`,
    maintenanceTitle: 'Maintenance & Support',
    maintenanceDesc: `Ensure the sustainability and security of your online presence with proactive 
                    maintenance service and responsive technical support. Focus on your business 
                    while I watch over your digital infrastructure.`,
    recommended: 'Recommended',
    learnMore: 'Learn more',
    needCustom: 'Need a custom solution? Contact me to discuss your project.',
    discussProject: 'Discuss your project',
    
    // Contact page
    contactTitle: 'Let\'s talk about your project',
    contactIntro: 'An idea? A project? Don\'t hesitate to contact me to discuss it.',
    fullName: 'Full name',
    email: 'Email address',
    subject: 'Subject',
    message: 'Message',
    sending: 'Sending...',
    send: 'Send message',
    successMessage: 'Your message has been sent successfully!',
    errorMessage: 'An error occurred while sending the message.',
    
    // Predefined subjects
    webSubject: 'Information Request - Web Development',
    seoSubject: 'Information Request - SEO & Digital Marketing',
    maintenanceSubject: 'Information Request - Maintenance & Support',
    
    // Skills page
    skillsTitle: 'My Skills',
    skillsIntro: 'Passionate about web technologies and DevOps, I have developed diverse expertise in full-stack development and system administration. My approach combines technical creativity and agile methodologies to create robust and scalable solutions.',
    
    // Projects page
    projectsTitle: 'My Projects',
    projectsIntro: 'Discover a selection of my achievements, showcasing my web development expertise and ability to create innovative solutions.',
    viewOnGithub: 'View on GitHub',
    interestedProjects: 'Interested in my work? Let\'s discuss your next project!',
    technologiesUsed: 'Technologies used',
    easyfoundTitle: 'EASYFOUND',
    easyfoundDesc: 'Automated Growth Hacking solution designed for ultra-personalized mass prospecting. Developed to maximize conversion rates without falling into spam, the platform integrates intelligent filtering algorithms and an optimized sending infrastructure.',
    afrixportTitle: 'AFRIXPORT B2B',
    afrixportDesc: 'B2B marketplace focused on African products. Built with Symfony, featuring vendor management, payments and logistics integrations. Live site: https://afrixportb2b.com/',
    bs2Title: 'BOXING SUPERSTAR 2 (BS2)',
    bs2Desc: 'Sequel to Boxing Superstar 1 with new features: advanced performance tracking, personalized coaching, social integration and UX/UI improvements.',
    
    // Language names
    languageFr: 'French',
    languageEn: 'English',
    languageLb: 'Luxembourgish',
    
    // Traductions des descriptions des projets
    immoTitle: 'Immo Île-de-France',
    immoDesc: 'Modernized platform for publishing and browsing real estate listings in Île-de-France. Intuitive interface allowing users to search, filter and publish listings easily.',
    
    boxingTitle: 'Boxing Superstar',
    boxingDesc: 'Innovative sports application dedicated to cardio development. Personalized performance tracking, creation of adapted training programs and real-time progress visualization.',
    
    delcoTitle: 'DELCO Forum',
    delcoDesc: 'Internal forum for DELCO employees facilitating communication and knowledge sharing. Complete system for user management, discussion categorization and real-time notifications.',
    
    rfTitle: 'RF - Region France',
    rfDesc: 'Web platform leveraging government API to explore French geographical data. Intuitive interface for visualizing and analyzing territorial data.',
    
    adoTitle: 'ADO.NET Library',
    adoDesc: 'Complete C# library offering CRUD functionalities for relational database management. Modular architecture and detailed documentation for easy integration.',
  },
  lb: {
    // Navigation
    accueil: 'Haaptsäit',
    competences: 'Fäegkeeten',
    services: 'Servicer',
    projects: 'Projeten',
    contact: 'Kontakt',
    
    // Home page
    role: 'Web Entwéckler & DevOps',
    greeting: 'Leidenschaftleche 21 Joer alen Entwéckler, kurz virum Master, ech transforméieren Iddie an aussergewéinlech digital Erfarungen.',
    description: 'Spezialiséiert am Web Entwécklung an DevOps, kombinéieren ech Kreativitéit a technesch Expertise fir innovativ Léisungen ze schafen déi d\'Erwaardunge iwwertreffen.',
    cv: 'Mäi CV kucken',
    contactMe: 'Kontaktéiert mech',
    seeProjects: 'Projete kucken',
    
    // Services page
    servicesTitle: 'Personaliséiert Léisunge fir Ären Digitale Succès',
    servicesIntro: `Transforméiert Är digital Visioun an d'Realitéit! Als passéierte Programméierer, 
                  setzen ech meng technesch Expertise a Kreativitéit an de Service vun Ärem Online-Erfolleg. 
                  Vum Design bis zur Maintenance, profitéiert vun enger perséinlecher Ënnerstëtzung 
                  fir Är digital Präsenz ze stäerken.`,
    webDevTitle: 'Web Entwécklung',
    webDevDesc: `Kreatioun vun innovative Websäiten an Applikatiounen, déi technesch Performance 
                mat exzeptioneller Benotzer-Erfarung kombinéieren. Vum Design bis zur Produktioun, 
                begleeden ech Iech bei der Realisatioun vun Ärer digitaler Visioun.`,
    seoTitle: 'SEO & Digital Marketing',
    seoDesc: `Maximéiert Är Online-Visibilitéit mat enger kompletter a personaliséierter SEO-Strategie. 
              Verbessert Är Plaz an de Sichmaschinen a generéiert qualifizéierten Traffic op Är Websäit.`,
    maintenanceTitle: 'Maintenance & Support',
    maintenanceDesc: `Garantéiert d'Nohaltegkeet an d'Sécherheet vun Ärer Online-Präsenz duerch proaktiv 
                    Maintenance a reaktive technesche Support. Konzentréiert Iech op Är Aktivitéit 
                    wärend ech Är digital Infrastruktur iwwerwaachen.`,
    recommended: 'Recommandéiert',
    learnMore: 'Méi gewuer ginn',
    needCustom: 'Braucht Dir eng personaliséiert Léisung? Kontaktéiert mech fir iwwer Äre Projet ze schwätzen.',
    discussProject: 'Iwwer Äre Projet schwätzen',
    
    // Contact page
    contactTitle: 'Kommt mir schwätzen iwwer Äre Projet',
    contactIntro: 'Eng Iddi? E Projet? Zéckt net fir mech ze kontaktéieren.',
    fullName: 'Kompletten Numm',
    email: 'E-Mail Adress',
    subject: 'Sujet',
    message: 'Message',
    sending: 'Gëtt geschéckt...',
    send: 'Message schécken',
    successMessage: 'Äre Message gouf erfollegräich geschéckt!',
    errorMessage: 'Et ass e Feeler beim Schécke vum Message opgetrueden.',
    
    // Predefined subjects
    webSubject: 'Informatiounsufro - Web Entwécklung',
    seoSubject: 'Informatiounsufro - SEO & Digital Marketing',
    maintenanceSubject: 'Informatiounsufro - Maintenance & Support',
    
    // Skills page
    skillsTitle: 'Meng Fäegkeeten',
    skillsIntro: 'Passéiert vu Web Technologien an DevOps, hunn ech eng divers Expertise am Full-Stack Entwécklung a System Administratioun entwéckelt. Meng Approche kombinéiert technesch Kreativitéit an agil Methodologie fir robust a skaléierbar Léisungen ze schafen.',
    
    // Projects page
    projectsTitle: 'Meng Projeten',
    projectsIntro: 'Entdeckt eng Auswiel vu menge Realisatiounen, déi meng Expertise an der Webentwicklung an meng Fäegkeet innovativ Léisungen ze schafen weisen.',
    viewOnGithub: 'Op GitHub kucken',
    interestedProjects: 'Interesséiert un menge Realisatiounen? Kommt mir schwätzen iwwer Äre Projet!',
    technologiesUsed: 'Benotzte Technologien',
    afrixportTitle: 'AFRIXPORT B2B',
    afrixportDesc: 'B2B-Marktplaz spezialiséiert op afrikanesch Produkter. Gemat mat Symfony, mat erweidertem Katalog, Verkeeferverwaltung, Bezuelungen an Logistik integréiert. Live Site: https://afrixportb2b.com/',
    bs2Title: 'BOXING SUPERSTAR 2 (BS2)',
    bs2Desc: 'Weiderentwécklung vu Boxing Superstar 1 mat neie Funktiounen: verbesserten Leeschtungssuivi, personaliséiert Coaching, sozial Integratioun an UX/UI Verbesserungen.',
    
    // Traductions des descriptions des projets
    immoTitle: 'Immo Île-de-France',
    immoDesc: 'Moderniséiert Plattform fir d\'Verëffentlechung an d\'Consultatioun vun Immobilienannoncen an der Île-de-France. Intuitiv Interface fir d\'Benotzer fir einfach Annoncen ze sichen, ze filtréieren an ze publizéieren.',
    
    boxingTitle: 'Boxing Superstar',
    boxingDesc: 'Innovativ Sportapplikatioun fir d\'Entwécklung vum Cardio. Personaliséiert Leeschtungsiwwerwaachung, Erstallung vu ugepassten Trainingsprogrammer a Visualiséierung vum Fortschrëtt an Echtzäit.',
    
    delcoTitle: 'DELCO Forum',
    delcoDesc: 'Interne Forum fir d\'Mataarbechter vu DELCO fir d\'Kommunikatioun an den Wëssensaustausch ze vereinfachen. Komplett System fir d\'Gestioun vun de Benotzer, Kategorisatioun vun Diskussiounen an Echtzäit-Notifikatiounen.',
    
    rfTitle: 'RF - Region France',
    rfDesc: 'Webplattform déi d\'Regierungsapi benotzt fir déi geografesch Donnéeë vu Frankräich ze exploréieren. Intuitiv Interface fir d\'Visualiséierung an d\'Analyse vun territorialen Donnéeën.',
    
    adoTitle: 'Bibliothéik ADO.NET',
    adoDesc: 'Komplett Bibliothéik a C# déi CRUD-Funktionalitéite fir d\'Gestioun vu relationale Donnéeën ubitt. Modulär Architektur a detailléiert Dokumentatioun fir eng einfach Integratioun.',
  }
};

// Créer le Provider
function LanguageProvider({ children }) {
  const [currentLang, setCurrentLang] = useState('fr');

  const value = {
    lang: currentLang,
    setLang: setCurrentLang,
    t: (key) => translations[currentLang][key] || key,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

// Exporter les deux
export { LanguageContext, LanguageProvider }; 